import * as React from "react";

import {
  AppBar,
  IconButton,
  Toolbar,
  MenuItem,
  Menu,
  Box,
  Typography,
  Avatar,
  Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";

import MenuIcon from "@mui/icons-material/Menu";
import { ExpandMore } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import Cookies from "js-cookie";

import { AppDispatch } from "../../store";
import { startLogout } from "../../store/auth";

import logoTicoTicket from "../../assets/images/logoticoticket.png";

type appbarComponentProps = {
  drawerWidth: number;
  title: string;
  handleDrawerToggle: any;
};

export const PlannerAppBar = ({
  drawerWidth,
  title,
  handleDrawerToggle,
}: appbarComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const name = Cookies.get("name");
  const email = Cookies.get("email");

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    dispatch(startLogout());
    handleCloseUserMenu();
  };

  const settings = [
    { label: "Mi Cuenta", path: "/account" },
    { label: "Mis tickets", path: "/account/tickets" },
    { label: "Cerrar Sesión", onClick: handleLogout, path: "/" },
  ];

  return (
    <AppBar
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        ml: { sm: `${drawerWidth}px` },
        py: 1,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ display: { sm: "none" } }}
        >
          <MenuIcon sx={{ mr: 2 }} />
          <Box
            component={RouterLink}
            to={`/`}
            sx={{
              display: "flex",
              alignItems: "center",
              marginRight: "auto",
              textDecoration: "none",
            }}
          >
            <img
              src={logoTicoTicket}
              alt="TicoTicket Logo"
              style={{
                height: "20px",
                width: "auto",
              }}
            />
          </Box>
        </IconButton>

        <Box
          component={RouterLink}
          to={`/`}
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            marginRight: "auto",
            textDecoration: "none",
          }}
        >
          <img
            src={logoTicoTicket}
            alt="TicoTicket Logo"
            style={{
              height: "30px",
              width: "auto",
            }}
          />
        </Box>

        <Tooltip title="Open settings">
          <Button 
            sx={{
              display: { xs: "none", sm: "flex" },
              width: "217px",
              height: "56px",
              padding: "0px 10px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "5px",
              background: "#221835",
              boxShadow: "0px 5px 5px 0px rgba(0, 0, 0, 0.30)",
              color: "#FFF",
              textTransform: "none",
            }}
            onClick={handleOpenUserMenu}
          >
            Hola, {name}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "30px",
                height: "30px",
                borderRadius: "100px",
                background: "#3DDC97",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              {name?.charAt(0).toUpperCase()}
            </Box>
          </Button>
          
          <Button 
            sx={{
              display: { xs: "flex", sm: "none" },
              width: "27px",
              height: "56px",
              padding: "0px 10px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "5px",
              background: "#221835",
              boxShadow: "0px 5px 5px 0px rgba(0, 0, 0, 0.30)",
              color: "#FFF",
              textTransform: "none",
            }}
            onClick={handleOpenUserMenu}
          >
          
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "30px",
                height: "30px",
                borderRadius: "100px",
                background: "#3DDC97",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              {name?.charAt(0).toUpperCase()}
            </Box>
          </Button>
        </Tooltip>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          {settings.map((setting) => (
            <MenuItem
              key={setting.label}
              onClick={() => {
                handleCloseUserMenu();
                setting.onClick && setting.onClick();
              }}
              component={RouterLink}
              to={setting.path}
            >
              <Typography>{setting.label}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
